module.exports = __webpack_public_path__ + "img/2.01f4a12c.png";